import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Material" }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalTableConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
// import { ExcelExporter } from '@/utils/ExcelExporter'
import { Excel, mergeListType } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic',
  setup(__props) {

const store = useStore()

initEmptyParam()
const userInfo = store.state.login.userInfo
let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    duration: 0,
    callCounts: 0,
    timeRange: 'today',
    callDate: [getBeforeDate('today'), getBeforeDate('today')],
    callTime: ['00', '23'],
    callType: 'meeting_voice_call',
    usedBy: userInfo.realName
  }
} else {
  queryParam.value = {
    duration: 0,
    callCounts: 0,
    timeRange: 'today',
    callDate: [getBeforeDate('today'), getBeforeDate('today')],
    callTime: ['00', '23'],
    callType: 'meeting_voice_call'
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {
      title: item.userName,
      value: item.userName
    }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const getGroupList = async () => {
  let groupData = await getListData(
    '/main/enterpriseWechat/dingDept/getGroupList',
    {}
  )
  const groupId = searchFormConfig.formItems.find(
    (item) => item.field === 'groupName'
  )
  groupId!.options = groupData.map((item: any) => {
    return { title: item.deptName, value: item.deptName }
  })
}
getGroupList()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData)
}

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}

getCompanyList()

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voice/queryExportData', queryInfo)
}

const getExportMergeData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voice/queryExportMergeData', queryInfo)
}

const getExportEveryDayData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voice/queryExportEveryDayData', queryInfo)
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

let callDuration = 2 * 60 // 单次通话时长，筛选大于这个值的通话记录
let totalCallDuration = 30 * 60 // 通话总时长，不达到则过滤掉

const handleVoiceFinance = (item: any) => {
  getExportData().then((res) => {
    let names = [] // 存储使用人，是一级key值，也是表格的行索引
    let dates = [] // 存储日期，是二级key值，也是表格的列索引
    let queryInfo = store.state.system.queryInfo
    // 根据日期范围，把每天日期字符串放进数组，后期根据这个日期范围，顺序地显示在表格里
    let startDate = queryInfo.callDate[0]
    let endDate = queryInfo.callDate[1]
    if (startDate && endDate) {
      let start = new Date(startDate)
      let end = new Date(endDate)
      while (start <= end) {
        dates.push(ts2str(start.getTime()).substring(0, 10))
        start.setDate(start.getDate() + 1)
      }
    }
    let mergeData = [] // 根据使用人，以及日期，汇总每天的通话时长和通话量
    let rawData = res // 用原始数据来计算汇总
    for (let i = 0; i < rawData.length; i++) {
      let data = rawData[i]
      let usedBy = data.usedBy
      let date = ts2str(Math.floor(data.msgTime)).substring(0, 10)
      let row: any = mergeData[usedBy]
      if (!row) {
        row = {
          usedBy: data.usedBy,
          deptName: data.deptName,
          parentDeptName: data.parentDeptName
        }
        mergeData[usedBy] = row
        names.push(usedBy)
      }
      if (!row[date]) {
        row[date] = {
          total: 0,
          count: 0
        }
      }
      row[date].total += data.duration // 当天，累加通话时长
      if (data.duration > callDuration) {
        // 当天，累加通话量，要求单次通话时长>2分钟
        row[date].count += 1
      }
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let usedBy = names[i]
      let row = mergeData[usedBy]
      for (let j = 0; j < dates.length; j++) {
        let date = dates[j]
        if (!row[date]) {
          continue
        }
        if (row[date].total < totalCallDuration) {
          continue
        }
        if (
          !queryInfo.usedBy &&
          row.deptName &&
          !row.deptName.match(/518.*|投教.*/)
        ) {
          // 部门名称应当符合正则：518.*|投教
          continue
        }

        exportData.push({
          date: date,
          usedBy: row.usedBy,
          parentDeptName: (row.parentDeptName || '-') + '',
          deptName: (row.deptName || '-') + '',
          duration: Math.round(row[date].total / 60),
          count: row[date].count
        })
      }
    }

    const header = [
      'date',
      'usedBy',
      'parentDeptName',
      'deptName',
      'duration',
      'count'
    ]
    const customHeader = [
      '日期',
      '姓名',
      '组',
      '岗位',
      '通话总时长(min)',
      '>2min次数'
    ]
    // 排序
    exportData.sort(function (a, b) {
      // 处理 parentDeptName 的比较
      const parentDeptA = a.parentDeptName || '';
      const parentDeptB = b.parentDeptName || '';

      if (parentDeptA === parentDeptB) {
        // 上级部门相同，比较 deptName
        const deptA = a.deptName || '';
        const deptB = b.deptName || '';

        if (deptA === deptB) {
          // 部门也相同，比较 usedBy
          const usedByA = a.usedBy || '';
          const usedByB = b.usedBy || '';
          return usedByA.localeCompare(usedByB, 'zh-Hans-CN');
        }
        return deptA.localeCompare(deptB, 'zh-Hans-CN');
      }
      return parentDeptA.localeCompare(parentDeptB, 'zh-Hans-CN');
    })

    // 文件名
    let filename =
      '财务数据导出-' + ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: filename,
      title: startDate + '至' + endDate + '财务数据',
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleVoiceExport = (item: any) => {
  getExportData().then((res) => {
    let customHeader = [
      '名称',
      '账户ID',
      '使用人',
      '组',
      '岗位',
      '企业号',
      '客户昵称',
      '客户UnionID',
      '通话总时长(分)',
      '通话总量'
    ]
    let header = [
      'userName',
      'fromUser',
      'usedBy',
      'parentDeptName',
      'deptName',
      'corpName',
      'toUserName',
      'userUnionId',
      'total',
      'count'
    ]
    // 数据按账号+主体汇总
    let mergeData: any = []
    let mergeKeys = []
    for (let i = 0; i < res.length; i++) {
      let key =
        res[i].corpId +
        ':' +
        res[i].fromUser +
        ':' +
        res[i].toUser +
        ':' +
        res[i].usedBy
      let group = mergeData[key]
      if (!group) {
        mergeKeys.push(key)
        group = {
          userName: res[i].userName,
          fromUser: res[i].fromUser,
          usedBy: res[i].usedBy,
          parentDeptName: res[i].parentDeptName,
          deptName: res[i].deptName,
          corpName: res[i].corpName,
          toUserName: res[i].toUserName,
          userUnionId: res[i].userUnionid,
          total: 0,
          count: 0
        }
        mergeData[key] = group
      }
      group.total += res[i].duration
      group.count += 1
    }
    let exportData = []
    for (let i = 0; i < mergeKeys.length; i++) {
      let key = mergeKeys[i]
      let row = mergeData[key]
      if (row['total'] < 10 * 20 * 60 && row['count'] < 10) {
        // 平均单次通话不超过20分钟，或者通话量不超过10次，不导出
        continue
      }

      row['total'] = Math.round(row['total'] / 60) //+"分"//+(row["total"]%60)+"秒"
      exportData.push(row)
    }
    if (exportData.length === 0) {
      ElMessage({
        type: 'error',
        message: '没有超时的通话记录'
      })
      return
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '超时通话统计-' + filename,
      title: '超时通话统计-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}
const handleEveryDay = (item: any) => {
  let queryInfo = store.state.system.queryInfo
  if (!queryInfo.usedBy) {
    ElMessage({
      type: 'error',
      message: '导出每日数据必须先指定使用人查询后才能导出！'
    })
    return
  }
  getExportEveryDayData().then((res) => {
    let customHeader = [
      '使用人',
      '组',
      '岗位',
      '日期',
      '通话总时长(分)',
      '通话量'
    ]
    let header = [
      'usedBy',
      'parentDeptName',
      'deptName',
      'startDate',
      'total',
      'count'
    ]

    // 按使用人汇总
    let mergeData: any = []
    let names = []
    for (let i = 0; i < res.length; i++) {
      let key = res[i].usedBy + ':' + res[i].beginDate
      let group = mergeData[key]
      if (!group) {
        group = {
          usedBy: res[i].usedBy,
          deptName: res[i].deptName,
          parentDeptName: res[i].parentDeptName,
          startDate: res[i].beginDate,
          total: 0,
          count: 0
        }
        mergeData[key] = group
        names.push(key)
      }
      group.total += res[i].duration
      group.count += res[i].callCounts
    }
    for (let key in mergeData) {
      let row = mergeData[key]
      row['total'] = Math.round(row['total'] / 60) //+ '分' + (row['total'] % 60) + '秒'
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let key = names[i]
      exportData.push(mergeData[key])
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')

    let mergeList: mergeListType[] = [
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 1,
        endColumn: 1
      },
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 2,
        endColumn: 2
      },
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 3,
        endColumn: 3
      }
    ]

    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长每日汇总-' + filename,
      title: '通话时长每日汇总-' + filename,
      data: reactive(exportData),
      header,
      customHeader,
      mergeList
    })
  })
}
const handleVoiceSum = (item: any) => {
  getExportMergeData().then((res) => {
    let customHeader = [
      '使用人',
      '组',
      '岗位',
      '开始日期',
      '结束日期',
      '通话总时长(分)',
      '通话量'
    ]
    let header = [
      'usedBy',
      'parentDeptName',
      'deptName',
      'startDate',
      'endDate',
      'total',
      'count'
    ]

    let queryInfo = store.state.system.queryInfo
    // 根据日期范围，把每天日期字符串放进数组，后期根据这个日期范围，顺序地显示在表格里
    let startDate = queryInfo.callDate[0]
    let endDate = queryInfo.callDate[1]

    // 按使用人汇总
    let mergeData: any = []
    let names = []
    for (let i = 0; i < res.length; i++) {
      let key = res[i].usedBy
      let group = mergeData[key]
      if (!group) {
        group = {
          usedBy: res[i].usedBy,
          deptName: res[i].deptName,
          parentDeptName: res[i].parentDeptName,
          startDate: startDate,
          endDate: endDate,
          total: 0,
          count: 0
        }
        mergeData[key] = group
        names.push(key)
      }
      group.total += res[i].duration
      group.count += res[i].callCounts
    }
    for (let key in mergeData) {
      let row = mergeData[key]
      row['total'] = Math.round(row['total'] / 60) //+ '分' + (row['total'] % 60) + '秒'
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let key = names[i]
      exportData.push(mergeData[key])
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长统计汇总-' + filename,
      title: '通话时长统计汇总-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleVoiceDetail = (item: any) => {
  getExportMergeData().then((res) => {
    let customHeader = [
      '名称',
      '账户ID',
      '使用人',
      '组',
      '岗位',
      '企业名称',
      '开始日期',
      '结束日期',
      '通话总时长(分)',
      '通话量'
    ]
    let header = [
      'accountName',
      'accountId',
      'usedBy',
      'parentDeptName',
      'deptName',
      'corpName',
      'beginDate',
      'endDate',
      'total1',
      'callCounts'
    ]
    let exportData = []
    for (let i = 0; i < res.length; i++) {
      let row = res[i]
      row['total1'] = Math.round(row['duration'] / 60) + '' //+"分"//+(row["total"]%60)+"秒"
      exportData.push(row)
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长统计-' + filename,
      title: '通话时长统计-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleSortDataChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [
  pageModalTableRef,
  defaultTableInfo,
  dataList,
  handleViewClick,
  dataCount,
  handleSortChange
] = usePageModalTable()
const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModalTable = _resolveComponent("PageModalTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "voice",
      onViewClick: _unref(handleViewClick),
      onVoiceFinance: handleVoiceFinance,
      onVoiceExport: handleVoiceExport,
      onVoiceEveryDay: handleEveryDay,
      onVoiceSum: handleVoiceSum,
      onVoiceDetail: handleVoiceDetail,
      onSortChange: handleSortDataChange
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onViewClick"]),
    _createVNode(_component_PageModalTable, {
      title: "",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: _unref(dataList),
      dataCount: _unref(dataCount),
      onSortChange: _unref(handleSortChange)
    }, {
      customName: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.customName +
            (scope.row.remark ? '(' + scope.row.remark + ')' : '')), 1)
      ]),
      beginTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatUnixTime(Number(scope.row.msgTime))), 1)
      ]),
      endTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatUnixTime(Number(scope.row.endTime) * 1000)), 1)
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(Number(scope.row.duration))), 1)
      ]),
      _: 1
    }, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount", "onSortChange"])
  ]))
}
}

})